<template>
  <div
    class="flex_box"
    :style="styleMerge"
  >
    <div class="current-active" />
    <div
      v-if="viewData.title"
      class="component-header"
    >
      <div
        class="component-title"
        :style="itemStyleMerge"
        :class="viewData.required ? 'required' : ''"
      >
        <div>{{ viewData.title }}</div>
        <div class="subtitle">
          {{ viewData.subtitle }}
        </div>
      </div>
      <div class="">
        <div class="three-dot" />
      </div>
    </div>
    <!-- <el-select v-model="viewData.selectVal" />     -->
    <el-select
      v-model="viewData.selectVal.defaultValue"
      :placeholder="viewData.placeholder"
      style="width: 100%"
    >
      <el-option
        v-for="item in viewData.selectVal.addOptions"
        :key="item.value"
        :label="item.label"
        :value="item.value"
      />
    </el-select>
  </div>
</template>
<script>
import formMixin from '@/view/weappTmp/core/lib/package/comps-node-mixin.js'
export default {
  name: 'SpSelect',
  mixins: [formMixin],
  props: {},
  data () {
    return {
      viewData: {
        selectVal: {}
      }
    }
  },
  watch: {},
  created () {},
  methods: {}
}
</script>

<style scoped lang="scss">
@import '@/weappTmps/formTmps/index.scss';
.flex_box {
  // 纵向
  &_Vertical {
  }
  // 横向
  &_Horizontal {
    display: flex;
  }
}
</style>
